export default [
  {
    path: "/Reception-Departments",
    name: "Reception-Departments",
    component: () => import("@/views/Reception/Reception.vue"),
    meta: {
      pageTitle: "Reception",
      resource: "reception",
    },
  },
  {
    path: "/Reception/Search",
    name: "Reception-Search",
    component: () => import("@/views/Reception/ReceptionSearch.vue"),
  },
  {
    path: "/Reception/Advance/Search",
    name: "Reception-Advance-Search",
    component: () => import("@/views/Reception/ReceptionSearchAdvance.vue"),
  },
  {
    path: "/Reception/Add",
    name: "Reception-AddNew",
    component: () => import("@/views/Reception/ReceptionAddNew.vue"),
  },
  {
    path: "/Search-Patient/Add",
    name: "Search-Patient-AddNew",
    component: () => import("@/views/Reception/ReceptionAddNew.vue"),
  },
  {
    path: "/Reception/Lobby",
    name: "Reception-Lobby",
    component: () => import("@/views/Reception/ReceptionLobby.vue"),
  },
  {
    path: "/Reception/Expired-Cards",
    name: "Reception-Expired-Cards",
    component: () => import("@/views/Reception/ReceptionExpiredCards.vue"),
  },
  {
    path: "/Reception/patient/preview/:id",
    name: "Reception-patient-preview",
    component: () => import("@/views/Reception/ReceptionPatientCard.vue"),
  },
  {
    path: "/Reception/patient/createCard/:id",
    name: "Reception-patient-create-card",
    component: () => import("@/views/Reception/ReceptionCreateCard.vue"),
  },
  {
    path: "/Reception/patient/history/:id/:id2",
    name: "Reception-patient-history",
    component: () => import("@/views/Reception/ReceptionPatientHistory.vue"),
  },
  {
    path: "/current-patient-form",
    name: "current-patient-form",
    component: () => import("@/views/Reception/CurrentPatientForm.vue"),
  },

  {
    path: "/out-clinic-recite-form",
    name: "out-clinic-recite-form",
    component: () => import("@/views/Reception/OutClinicRecite.vue"),
  },
  {
    path: "/payment-recite-form",
    name: "payment-recite-form",
    component: () => import("@/views/Reception/PaymentRecite.vue"),
  },
  {
    path: "/ivf-expenses-form",
    name: "ivf-expenses-form",
    component: () => import("@/views/Reception/IvfExpensesForm.vue"),
  },
  {
    path: "/invoice-form",
    name: "invoice-form",
    component: () => import("@/views/Reception/InvoiceForm.vue"),
  },
  {
    path: "/active-patient-card/:id/:is_active/:card_id",
    name: "active-patient-card",
    component: () => import("@/views/Reception/ActivePatientCard.vue"),
  },

  {
    path: "/patient-history",
    name: "patient-history",
    component: () => import("@/views/Reception/PatientHistory.vue"),
  },
  {
    path: "/patient-card-history/:id",
    name: "patient-card-history",
    component: () => import("@/views/Reception/PatientCardHistoryTable.vue"),
  },
  {
    path: "/patient-card-timeline/:id/:date?",
    name: "patient-card-timeline",
    component: () => import("@/views/Reception/PatientCardTimeline.vue"),
  },

  {
    path: "/register-patient/:id?",
    name: "register-patient",
    component: () => import("@/views/Reception/RegisterPatient.vue"),
  },
  {
    path: "/patient-card-by-qr/:id",
    name: "patient-card-by-qr",
    component: () => import("@/views/Reception/PatientCardViewByQR.vue"),
  },
  {
    path: "/out-clinic-invoices/:name/:id",
    name: "out-clinic-invoices",
    component: () => import("@/views/Reception/PatientOutClinicInvoice.vue"),
  },
  {
    path: "/QuickInvoice",
    name: "quick-invoice",
    component: () => import("@/views/Reception/QuickInvoice.vue"),
  },
  {
    path: "/Booking",
    name: "booking",
    component: () => import("@/views/Reception/Booking.vue"),
  },
  {
    path: "/add-patient-to-sergery",
    name: "add-patient-to-sergery",
    // component: () => import("@/views/Reception/AddPatientToSurgery.vue"),
    component: () => import("@/views/surgery/SurgeryPatient.vue"),
  },
  {
    path: "/Reception-add-patient-surgery/:id",
    name: "Reception-add-patient-surgery",
    component: () => import("@/views/Reception/AddPatientSurgeryInfo.vue"),
  },
  {
    path: "/Reception/Cashier-Invoices",
    name: "Reception-Cashier-Invoices",
    component: () => import("@/views/Reception/CashierInvoices.vue"),
    meta: {
      pageTitle: "Receive Payments",
      resource: "reception",
    },
  },
  {
    path: "/Reception/Floors",
    name: "Reception-Floors",
    component: () => import("@/views/Reception/FloorsList.vue"),
    meta: {
      pageTitle: "Floors",
      resource: "reception",
    },
  },
  {
    path: "/Reception/Floor/:floorId/Rooms",
    name: "Reception-Floor-Rooms",
    component: () => import("@/views/Reception/FloorRooms.vue"),
    meta: {
      pageTitle: "Floor Rooms",
      resource: "reception",
    },
  },
  {
    path: "/Reception/Booking",
    name: "Reception-Booking",
    component: () => import("@/views/Reception/Booking.vue"),
    meta: {
      pageTitle: "Booking",
      resource: "reception",
    },
  },
];
